import { ResearchAuthServiceContext } from './researchAuthServiceContext';
import { ReplaySubject, Observable, timer, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ResearchAuthService {
    private static refreshUrl: string;
    static get RefreshUrl(): string {
        return ResearchAuthService.refreshUrl;
    }

    private context: ResearchAuthServiceContext;
    private responseSubject = new ReplaySubject<HttpErrorResponse>(1);
    private userClaimResult: any;
    private redirectRoute = '';
    private timerSubscription: Subscription;

    get loginRoute(): string {
        return this.context.loginRoute;
    }

    get afterLoginRoute(): string {
        return this.redirectRoute || this.context.afterLoginRoute;
    }

    get afterLogoutRoute(): string {
        return this.context.afterLogoutRoute;
    }

    constructor(private http: HttpClient) {
    }

    public initialize(context: ResearchAuthServiceContext): void {
        this.context = context;
        this.userClaimResult = this.context.initializeClaims();
        ResearchAuthService.refreshUrl = context.userInfoUrl;
        this.initializeRefresh();
    }

    public userClaimsExist(): boolean {
        return this.userClaimResult !== null && this.userClaimResult !== undefined;
    }

    public login(): void {
        window.location.href = `${this.context.signInUrl}?redirect_uri=${this.redirectRoute}`;
    }

    public logout(): void {
        window.location.href = this.context.signOutUrl;
    }

    public refresh(): void {
        this.timerSubscription.unsubscribe();
        this.initializeRefresh();
    }

    public onUnathenticatedResponse(): Observable<HttpErrorResponse> {
        return this.responseSubject;
    }

    public sendUnathenticatedError(response: HttpErrorResponse) {
        this.responseSubject.next(response);
    }

    public deepLinkRoute(route: string) {
        this.redirectRoute = route;
    }

    private readClaims(response: any): void {
        this.userClaimResult = this.context.getClaims(response);
    }

    private initializeRefresh(): void {
        const delay = (1000 * (this.context.extendSessionDelay || 600));

        this.timerSubscription = timer(0, delay)
            .pipe(switchMap(i => this.http.get(ResearchAuthService.refreshUrl)))
            .subscribe(i => {
                if (i) {
                    this.readClaims(i);
                }
            });
    }
}
